import { useEffect, useMemo, useState } from 'react';
import { fetchRawAllAppSettings } from './useFetchRawAllAppSettings';
import { fetchObjectTypeNamesToIds } from './useFetchObjectTypeNamesToIds';
import { FetchStatuses } from '../../types/FetchStatus';
const getAllAppSettingsByObjectTypeId = (rawAllAppSettings, objectTypeNamesToIds) => {
  return Object.keys(rawAllAppSettings).reduce((appSettings, objectTypeName) => {
    const objectTypeId = objectTypeNamesToIds.get(objectTypeName);
    if (objectTypeId) {
      appSettings.set(objectTypeId, rawAllAppSettings[objectTypeName]);
    }
    return appSettings;
  }, new Map());
};
export const fetchAllAppSettings = () => {
  const allRawAppSettingsPromise = fetchRawAllAppSettings();
  const objectTypeNamesToIdsPromise = fetchObjectTypeNamesToIds();
  return Promise.all([allRawAppSettingsPromise, objectTypeNamesToIdsPromise]).then(([rawAllAppSettings, objectTypeNamesToIds]) => {
    return getAllAppSettingsByObjectTypeId(rawAllAppSettings, objectTypeNamesToIds);
  });
};
export const useFetchAllAppSettings = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState();
  useEffect(() => {
    fetchAllAppSettings().then(result => {
      setData(result);
    }).catch(err => setError(err)).finally(() => setLoading(false));
  }, []);
  return useMemo(() => {
    if (error) {
      return {
        data: null,
        status: FetchStatuses.REJECTED,
        error
      };
    }

    // Combined LOADING state
    if (loading) {
      return {
        data: null,
        status: FetchStatuses.LOADING
      };
    }
    if (data) {
      return {
        data,
        status: FetchStatuses.RESOLVED
      };
    }

    // Combined IDLE state
    return {
      data: null,
      status: FetchStatuses.IDLE
    };
  }, [error, loading, data]);
};